import { EVENT_SUMMARY_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const AdminEventSummaryService = {
  getAll: (params: any) => requests.get(`${EVENT_SUMMARY_URL}`, params),
  create: (params: any) => requests.post(`${EVENT_SUMMARY_URL}`, params, true),
  getSingle: (id: number) => requests.get(`${EVENT_SUMMARY_URL}/${id}`),
  update: (params: any, id: number) =>
    requests.post(`${EVENT_SUMMARY_URL}/${id}`, params, true),
  delete: (id: number) => requests.delete(`${EVENT_SUMMARY_URL}/${id}`),
};
